import * as yup from "yup";

export const redefinirSenhaSchema = yup.object().shape({
  email: yup.string().required("E-mail é um campo obrigatório"),
});
